import { memo, useEffect, useState } from 'react';
import cn from 'classnames';
import { IPublisher } from 'src/interface';
import { ObjectUtils } from 'src/utils';
import { Element, Image, LazyloadImage } from 'src/components';
import styles from './styles.module.scss';
import { useWindowSize } from 'react-use';

interface IProps {
    publisher?: IPublisher;
    hStyle?: number;
    mhStyle?: number;
    lazyloadImage?: boolean;
}
export function ContentPublisher({
    publisher = {} as IPublisher,
    hStyle = 12,
    mhStyle = 12,
    lazyloadImage = true,
}: IProps) {
    const size = useWindowSize();
    // const _hStyle = size.width < 360 ? mhStyle : hStyle;
    const [_hStyle, setHeight] = useState<number>(hStyle);
    if (ObjectUtils.isEmpty(publisher)) {
        return null;
    }

    useEffect(() => {
        if (window.innerWidth < 360) {
            setHeight(mhStyle);
        }
    }, []);

    return (
        <Element
            className={cn(styles['bm-card-source'])}
            aria-label="Tới trang nhà xuất bản"
        >
            {lazyloadImage ? (
                <LazyloadImage
                    src={publisher.logo}
                    alt={publisher.name}
                    width={publisher.width || 1}
                    height={publisher.height || 1}
                    style={{
                        width:
                            (_hStyle * (publisher.width || 1)) /
                            (publisher.height || 1),
                        height: _hStyle,
                    }}
                    aria-label="Logo nhà xuất bản"
                />
            ) : (
                <Image
                    src={publisher.logo}
                    alt={publisher.name}
                    width={publisher.width || 1}
                    height={publisher.height || 1}
                    style={{
                        width:
                            (_hStyle * (publisher.width || 1)) /
                            (publisher.height || 1),
                        height: _hStyle,
                    }}
                    aria-label="Logo nhà xuất bản"
                />
            )}

            {publisher.showName && (
                <Element renderAs="span" className={styles['source']}>
                    {publisher.shortName}
                </Element>
            )}
        </Element>
    );
}

export default memo(ContentPublisher);
